import React, { useState } from "react";
import axios from "axios";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, Button, UncontrolledTooltip, CustomInput} from "reactstrap";
import { Link } from "react-router-dom";
import { getCookie } from "../jwt/_helpers/cookie";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const ReleaseDropdown = ({
  id,
  ean,
  status,
  action,
  todUrl,
  touUrl,
  ppUrl,
  canAddTakedown,
  has_delivery_confirmations,
  release_admin_approval,
  is_premium_user,
  is_sub_user,
  is_employee_account,
  all_tracks_ready,
  has_blacklisted_artist,
  atleast_33_pct_listened_per_track,
  is_subuser_release,
  preScanEnabled,
  pre_scan_done,
  pre_scan,
}) => {
  const tokenAPI = getCookie("token");
  const {setSuccessAction, forceUpdate, setForceUpdate} = action;
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);

  const [openDistribute, setOpenDistribute] = useState(false);
  const [openFinishEditing, setOpenFinishEditing] = useState(false);
  const [openTakeDown, setOpenTakeDown] = useState(false);
  const [openRejectRelease, setOpenRejectRelease] = useState(false);
  const [distributedModals, setDistributeModals] = useState({type: null, isOpen: false})
  const [artificialStreamingDeclaration, artificialStreamingDeclarationSET] = useState(false);

  const isCurrentUserPremiumOrEmployee = is_premium_user || is_employee_account;

  const preScanDeclarationRequired = pre_scan_done && pre_scan.alert && pre_scan.scanned_tracks;
  const preScanDeclarationSubmitted = pre_scan && pre_scan.admin_declaration;
  const distributionDisabledPreScanNotDone = (preScanEnabled && !pre_scan_done) ;
  const distributionDisabledPreScanDeclarationNotSubmitted = (preScanEnabled && preScanDeclarationRequired && !preScanDeclarationSubmitted);

  let showPendingStatus = is_subuser_release && isCurrentUserPremiumOrEmployee && status === "ready";
  status = showPendingStatus ? "pending" : status;

  const patchRelease = (ID, status, func) => {
    axios({
      method: "patch",
      mode: 'cors',
      url: `${API_URL}releases/${ID}/`,
      data:{
        "status": status
      },
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      if (response.status === 200) {
        setSuccessAction(true);
        setForceUpdate(forceUpdate + 1);
        if (func){
          func();
        }

        setTimeout(() => {
          setSuccessAction(false);
        }, (3000));
      }
    });
  }

// BE VALUES - API Pretty Values
// offline - Offline
// takedown_request - Takedown requested
// taken_down - Taken down
// re_delivery-delivery - Re-delivery
// ready - Ready
// approval - Submission Queued
// locked - In Progress - Locked
// delivering - Delivering
// unlocked - Please Edit
// distributed - Distributed
// live - Live

  return (
    <>
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        Action
      </DropdownToggle>
      {
        status === "distributed" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "release"})}>Edit Release Metadata</DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "tracks"})}>Edit Tracks</DropdownItem>
          {canAddTakedown && <DropdownItem onClick={() => setOpenTakeDown(true)}>Takedown</DropdownItem>}
          {has_delivery_confirmations && <DropdownItem><Link to={`/releases/${id}/delivered-list/`}>Delivered List</Link></DropdownItem>}
          {!has_delivery_confirmations && <DropdownItem disabled>Delivered List</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "locked" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem disabled>
            Edit Release Metadata
          </DropdownItem>
          <DropdownItem disabled>
            Edit Tracks
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "delivering" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem disabled>
            Edit Release Metadata
          </DropdownItem>
          <DropdownItem disabled>
            Edit Tracks
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "unlocked" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "release"})}>Edit Release Metadata</DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "tracks"})}>Edit Tracks</DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "pending" && (
        <DropdownMenu>
          <>
            <DropdownItem disabled id={`disp-tooltip-id-${id}`}>Distribute</DropdownItem>
            <UncontrolledTooltip
              placement="top"
              trigger="hover"
              target={`disp-tooltip-id-${id}`}
            >
              This release is pending Distribute action from user.
            </UncontrolledTooltip>
          </>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>Edit Release Metadata</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/tracks`}>Edit Tracks</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "ready" && (
        <DropdownMenu>
          {
            is_sub_user && (
              <>
                <DropdownItem 
                  onClick={() => setOpenDistribute(true)} 
                  disabled={!all_tracks_ready || has_blacklisted_artist}
                  id={`resdis-tooltip-id-${id}`}
                >
                  Distribute
                </DropdownItem>

                {(!all_tracks_ready || has_blacklisted_artist) && (
                  <UncontrolledTooltip
                    placement="top"
                    trigger="hover"
                    target={`resdis-tooltip-id-${id}`}
                  >
                    {
                      (has_blacklisted_artist) && <>
                        This release cannot be distributed as it contains one or more tracks from a blacklisted artist. Please contact our support team for further information.
                        <br/><br/>
                      </>
                    }

                    {
                      (!all_tracks_ready && !has_blacklisted_artist) && <>
                      Please submit the metadata for all Tracks in order to Distribute the Release.
                      <br/><br/>
                      </>
                    }
                  </UncontrolledTooltip>
                )}
              </>
            )
          }

          {
            (is_premium_user || is_employee_account) && (
              <>
                <DropdownItem 
                  onClick={() => setOpenDistribute(true)} 
                  disabled={!all_tracks_ready || has_blacklisted_artist || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted}
                  id={`resdis-tooltip-id-${id}`}
                >
                  Distribute
                </DropdownItem>

                {(!all_tracks_ready || has_blacklisted_artist || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted) && (
                  <UncontrolledTooltip
                    placement="top"
                    trigger="hover"
                    target={`resdis-tooltip-id-${id}`}
                  >
                    {
                      (distributionDisabledPreScanNotDone) && <>
                      Please perform pre scan first in order to distribute the release.
                      <br/><br/>
                      </>
                    }
                    {
                      (distributionDisabledPreScanDeclarationNotSubmitted) && <>
                      Please submit the pre-scan declaration first in order to distribute the release.
                      <br/><br/>
                      </>
                    }
                    {
                      (has_blacklisted_artist) && <>
                        This release cannot be distributed as it contains one or more tracks from a blacklisted artist. Please contact our support team for further information.
                        <br/><br/>
                      </>
                    }

                    {
                      (!all_tracks_ready && !has_blacklisted_artist) && <>
                      Please submit the metadata for all Tracks in order to Distribute the Release.
                      <br/><br/>
                      </>
                    }
                  </UncontrolledTooltip>
                )}
              </>
            )
          }
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>Edit Release Metadata</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/tracks`}>Edit Tracks</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "approval" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem disabled>
            Edit Release Metadata
          </DropdownItem>
          <DropdownItem disabled>
            Edit Tracks
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        (release_admin_approval && status === "admin_approval") &&
        <>
          {
            is_sub_user && (
              <DropdownMenu>
                <DropdownItem disabled>Distribute</DropdownItem>
                <DropdownItem>
                  <Link to={`/releases/${id}/view/`}>View Release</Link>
                </DropdownItem>
                <DropdownItem disabled>
                  Edit Release Metadata
                </DropdownItem>
                <DropdownItem disabled>
                  Edit Tracks
                </DropdownItem>
                {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
              </DropdownMenu>
            )
          }

          {
            (is_premium_user || is_employee_account) && (
              <DropdownMenu>
                {
                  (atleast_33_pct_listened_per_track && !distributionDisabledPreScanNotDone && !distributionDisabledPreScanDeclarationNotSubmitted) ? (
                    <DropdownItem onClick={() => setOpenDistribute(true)}>Distribute</DropdownItem>
                  ) : (
                    <>
                      <DropdownItem disabled id={`lp-tooltip-id-${id}`}>Distribute</DropdownItem>
                      <UncontrolledTooltip
                        placement="top"
                        trigger="hover"
                        target={`lp-tooltip-id-${id}`}
                      >
                        {
                          distributionDisabledPreScanNotDone && <>Please perform pre scan first in order to distribute the release.<br/><br/></>
                        }
                        {
                          distributionDisabledPreScanDeclarationNotSubmitted && <>Please submit the pre-scan declaration first in order to distribute the release.<br/><br/></>
                        }
                        {
                          !atleast_33_pct_listened_per_track && <>Please listen tracks carefully in full length to ensure the release is ready to be distributed.<br/><br/></>
                        }
                      </UncontrolledTooltip>
                    </>
                  )
                }
                <DropdownItem>
                  <Link to={`/releases/${id}/view/`}>View Release</Link>
                </DropdownItem>
                <DropdownItem>
                  <Link to={`/releases/${id}/update/`}>Edit Release Metadata</Link>
                </DropdownItem>
                <DropdownItem>
                  <Link to={`/releases/${id}/tracks`}>Edit Tracks</Link>
                </DropdownItem>
                {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
                {canAddTakedown && <DropdownItem onClick={() => setOpenRejectRelease(true)}>Reject Release</DropdownItem>}
                {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
              </DropdownMenu>          
            )
          }
        </>
      }
      {
        status === "re_delivery-delivery" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem disabled>
            Edit Release Metadata
          </DropdownItem>
          <DropdownItem disabled>
            Edit Tracks
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "re_delivery-editing" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>Edit Release Metadata</Link>
          </DropdownItem>
          <DropdownItem onClick={() => setOpenFinishEditing(true)}>Submit Editing</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/tracks`}>Edit Tracks</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "takedown_request" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem disabled>
            Edit Release Metadata
          </DropdownItem>
          <DropdownItem disabled>
            Edit Tracks
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "taken_down" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem disabled>
            Edit Release Metadata
          </DropdownItem>
          <DropdownItem disabled>
            Edit Tracks
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "offline" && (
        <DropdownMenu>
          <DropdownItem disabled>Distribute</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>View Release</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>Edit Release Metadata</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/tracks`}>Edit Tracks</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>Takedown</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}} >Copy EAN/UPC</DropdownItem>}
        </DropdownMenu>
        )
      }
    </ButtonDropdown>


    <Modal isOpen={distributedModals.isOpen} centered={true}>
      <ModalHeader>Are you really sure you want to do edit metadata?</ModalHeader>
      <ModalBody>
        <p><b>This will change your metadata and can affect the release.</b></p>
        <p>Proceed only if you are completely sure.</p>
        <p><b>PLEASE DO NOT</b> edit metadata just for testing and exploring.</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setDistributeModals({isOpen: false, type: null})}>
          Cancel
        </Button>
        <Button color="success">
          {
            distributedModals.type === 'tracks' ?
            <Link to={`/releases/${id}/tracks`}>I understand</Link>
            :
            <Link to={`/releases/${id}/update/`}>I understand</Link>
          }
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={openDistribute} centered={true} style={{ maxWidth: '70%' }}>
      <ModalHeader>Are you sure all information entered is valid and represents this release fully?</ModalHeader>
      <ModalBody>
        <p>After this action, your release will be checked and if the information is correct it will be distributed on the official and exclusive distribution dates.</p>
        <p>By confirming and accepting this form, you are fully accepting and complying with the <a href={todUrl} target="blank" rel="noopener noreferrer">Terms Of Distribution</a>, <a href={touUrl} target="blank" rel="noopener noreferrer">Terms Of Use</a> and <a href={ppUrl} target="blank" rel="noopener noreferrer">Privacy Policy</a>.</p>
        <p>By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.</p>
        <p>Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute. </p>

        <div className="mt-4">
          <h6><u>Artificial Streaming Declaration</u></h6>
          <p><strong>1.</strong> I fully understand and agree not to engage in any form of artificial streaming, including the use of bots, streaming farms, or any method that manipulates DSP metrics.</p>
          <p><strong>2.</strong> I will not pay or offer payment for playlist placements, nor will I work with any third party promising guaranteed placements — I understand this is considered fraud and a scam.</p>
          <p><strong>3.</strong> I acknowledge that any such actions may result in immediate termination, forfeiture of royalties, legal claims, contractual penalties and fees, and reporting to DSPs and authorities.</p>
          <p><strong>4.</strong> I also guarantee to inform and educate any artists or clients I work with about these rules and ensure they comply.</p>
          <p><strong>5.</strong> I understand that if I engage in artificial streaming, my KYC data, including my full name, address, ID card, and other personal information, can be shared with the DSP's legal departments, such as those of Spotify, Apple Music, and others.</p>
          <p><strong>6.</strong> I accept full legal responsibility for any violations.</p>

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <CustomInput
              type="checkbox"
              id="artificialStreamingDeclaration"
              name="artificialStreamingDeclaration"
              checked={artificialStreamingDeclaration}
              value={artificialStreamingDeclaration}
              onChange={(e) => { artificialStreamingDeclarationSET(!artificialStreamingDeclaration)}}
            />
            <h6 className="mt-2">
              I hereby acknowledge and agree to abide by the above Artificial Streaming terms, and I accept full legal responsibility for any violations.
            </h6>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenDistribute(false)}>
          Cancel
        </Button>
        <Button
          color="success"
          onClick={() => {
            let newStatus = (release_admin_approval && is_sub_user) ? "admin_approval" : "approval";
            patchRelease(id, newStatus, setOpenDistribute(false));
          }}
          disabled={!artificialStreamingDeclaration}
        >
          Confirm and Accept
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={openTakeDown} centered={true}>
      <ModalHeader>Are you sure you want to remove this release from all stores?</ModalHeader>
      <ModalBody>
      This action is irreversible.
      <p>By taking this release down, you are complying with the <a href={todUrl} target="blank" rel="noopener noreferrer">Terms Of Distribution</a>, <a href={touUrl} target="blank" rel="noopener noreferrer">Terms Of Use</a> and <a href={ppUrl} target="blank" rel="noopener noreferrer">Privacy Policy</a>.</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenTakeDown(false)}>
          Cancel
        </Button>
        <Button color="success" onClick={() => patchRelease(id, 'takedown_request', setOpenTakeDown(false))}>
          Confirm and Accept
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={openFinishEditing} centered={true}>
      <ModalHeader>Are you sure all information entered is valid and represents this release fully?</ModalHeader>
      <ModalBody>
      <p>After this action, your release will be checked and if the information is correct it will be re-distributed to the DSP partners. <b>NOTE, only METADATA will be sent to DSP-s, content such as IMAGE and AUDIO files can not be updated this way.</b></p><p> By confirming and accepting this form, you are fully accepting and complying with the <Link to={"/terms-and-conditions"} target="_blank">Terms Of Use</Link> and Terms of our Exclusive Distribution Agreement.</p><p> By confirming and accepting this form, you are fully accepting and complying with the <Link to={"/privacy-policy"} target="_blank">Privacy Policy</Link>.</p><p>By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.</p><p>Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute. </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenFinishEditing(false)}>
          Cancel
        </Button>
        <Button color="success" onClick={() => patchRelease(id, 're_delivery-delivery', setOpenTakeDown(false))}>
        Confirm and Accept
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={openRejectRelease} centered={true}>
      <ModalHeader>Are you sure you want to reject this release?</ModalHeader>
      <ModalBody>
        This action is irreversible. After this action, the release will go to <b>Taken down</b> status.
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenRejectRelease(false)}>
          Cancel
        </Button>
        <Button color="success" onClick={() => patchRelease(id, 'taken_down', setOpenRejectRelease(false))}>
          Confirm and Accept
        </Button>
      </ModalFooter>
    </Modal>

    </>
  );
};

export default ReleaseDropdown;
